import { takeEvery, put } from 'redux-saga/effects';
import * as types from '../constants';
import * as modalTypes from './types';

function* rootSagas() {
    yield takeEvery([
        'ws:User/UserShowOrderDetailsNotification',
    ], function* (payload) {
        yield put({
            type: types.SOCKET_MODAL_SHOW,
            data: {
                type: modalTypes.TYPE_ORDER_DETAILS,
                ...payload.data
            },
        })
    });
}

export default rootSagas;
